import UPLOAD_FILE from './uploadFile.gql';
import UPLOAD_FILE_WITH_SIGNATURE from './uploadFileWithSignature.gql';
import DELETE_FILE from './deleteFile.gql';

export { UPLOAD_FILE, UPLOAD_FILE_WITH_SIGNATURE, DELETE_FILE };
